export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('token');
    if (!raw) return null;
    const [, payloadBase64] = raw.split('.');
    if (!payloadBase64) return null;
    const decoded = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
    
    // Normalize field names
    return {
      userId: decoded.id || decoded._id,
      role: decoded.role,
      supplierId: decoded.supplierId,
      email: decoded.email,
    };
  } catch {
    return null;
  }
}
